import { createApi } from '@reduxjs/toolkit/query/react';
import { dynamicBaseQuery } from '../badRequestHandler';

export const rouletteApi = createApi({
  reducerPath: 'rouletteApi',
  baseQuery: dynamicBaseQuery,
  tagTypes: ['Roulette'],
  endpoints: (builder) => ({
    getRouletteActiveGames: builder.query({
      query: () => ({ url: '/api/roulette/admin/active-games', method: 'GET' }),
      providesTags: ['Roulette'],
    }),
    getRouletteRoundBets: builder.query({
      query: ({ roundId, page = 1, limit = 20 } = {}) => {
        const params = new URLSearchParams({ page, limit });
        if (roundId) params.append('roundId', roundId);
        return { url: `/api/roulette/admin/round-bets?${params.toString()}`, method: 'GET' };
      },
      providesTags: ['Roulette'],
    }),
    getRouletteRounds: builder.query({
      query: ({ fromDate, toDate, page = 1, limit = 20 } = {}) => {
        const params = new URLSearchParams({ page, limit });
        if (fromDate) params.append('fromDate', fromDate);
        if (toDate)   params.append('toDate', toDate);
        return { url: `/api/roulette/admin/rounds?${params.toString()}`, method: 'GET' };
      },
      providesTags: ['Roulette'],
    }),
    getRouletteCompanyReport: builder.query({
      query: ({ userId, fromDate, toDate } = {}) => {
        const params = new URLSearchParams();
        if (userId)   params.append('userId', userId);
        if (fromDate) params.append('fromDate', fromDate);
        if (toDate)   params.append('toDate', toDate);
        return { url: `/api/roulette/admin/company-report?${params.toString()}`, method: 'GET' };
      },
      providesTags: ['Roulette'],
    }),
    getRouletteCurrentRound: builder.query({
      query: () => ({ url: '/api/roulette/admin/current-round', method: 'GET' }),
      providesTags: ['Roulette'],
    }),
    getRouletteResults: builder.query({
      query: ({ limit = 15 } = {}) => ({ url: `/api/roulette/admin/results?limit=${limit}`, method: 'GET' }),
      providesTags: ['Roulette'],
    }),
    getRouletteInplayBets: builder.query({
      query: () => ({ url: '/api/game/admin/inplay-bets?game=roulette', method: 'GET' }),
      providesTags: ['Roulette'],
    }),

    getRouletteMode: builder.query({
      query: () => ({ url: '/api/roulette/admin/mode', method: 'GET' }),
      providesTags: ['Roulette'],
    }),

    setRouletteMode: builder.mutation({
      query: (body) => ({ url: '/api/roulette/admin/set-mode', method: 'POST', body }),
      invalidatesTags: ['Roulette'],
    }),
  }),
});

export const {
  useGetRouletteActiveGamesQuery,
  useGetRouletteRoundBetsQuery,
  useGetRouletteRoundsQuery,
  useGetRouletteCompanyReportQuery,
  useGetRouletteCurrentRoundQuery,
  useGetRouletteResultsQuery,
  useGetRouletteInplayBetsQuery,
  useGetRouletteModeQuery,
  useSetRouletteModeMutation,
} = rouletteApi;

export default rouletteApi;
